export const andesSaferpayFieldStyles = {
    '.form-control': `height: 44px !important; 
  background-color: #fff;
  border: 1px solid #e7e5e4;
  border-radius: .375rem;
  outline: none;`,
    '.form-control.is-touched.is-valid': 'border-color: #15803d;',
    '.form-control.is-touched.is-invalid': 'border-color: #b91c1c;',
    '.form-control.input-small,.form-control.input-large': 'width: calc(100% - 1px);',
    '.form-control:hover': 'border-color: #404040;',
    '.cvc__input': 'padding-right: 44px;',
};
export const SAFERPAY_SCRIPT_ID = 'saferpay-script';
